export function Unit(value) {
  return Number(parseInt(value));
}
